import pmImpactAnalysisService from '@/services/pmImpactAnalysisService';
import { isCockpitFullView } from '@/utils/cockpitDisplay';
import { impactPpcBars, impactTbiBars } from '@/utils/impactAnalysisDisplay';

export default {
  namespaced: true,

  state: {
    loading: false,
    error: null,
    data: null,
    weeks: 8,
  },

  getters: {
    loading: (state) => state.loading,
    error: (state) => state.error,
    data: (state) => state.data,
    weeks: (state) => state.weeks,
    insufficientData: (state) => Boolean(state.data?.insufficientData),
    patternDetected: (state) => Boolean(state.data?.patternDetected),
    periodLabel: (state) => state.data?.periodLabel || '',
    wirkkette: (state) => state.data?.wirkkette || null,
    tbiCurrent: (state) => state.data?.tbi?.current || null,
    tbiHistory: (state) => state.data?.tbi?.history || [],
    tbiBars: (state, getters) => impactTbiBars(getters.tbiHistory),
    ppcCurrent: (state) => state.data?.ppc?.current || null,
    ppcHistory: (state) => state.data?.ppc?.history || [],
    ppcBars: (state, getters) => impactPpcBars(getters.ppcHistory),
    ppcTarget: (state) => state.data?.ppc?.targetPercent ?? 80,
    causes: (state) => state.data?.causes || { totalBreaks: 0, distribution: [], dominant: null },
    constraints: (state) => state.data?.constraints || { items: [], summary: { total: 0, intern: 0, cross: 0 } },
    milestones: (state) => state.data?.milestones || [],
    forecast: (state) => state.data?.forecast || null,
    fuehrungsimpuls: (state) => state.data?.fuehrungsimpuls || null,
    interfaceQuality: (state) => state.data?.interfaceQuality || null,
    dimensions: (state) => state.data?.dimensions || null,
    dataBasis: (state) => state.data?.dataBasis || null,
    canSeeImpuls(_state, _getters, _rootState, rootGetters) {
      return isCockpitFullView({
        user: rootGetters.getUser,
        selectedProject: rootGetters['pmProject/selectedProject'],
      });
    },
    isFullView(_state, getters) {
      return getters.canSeeImpuls;
    },
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_WEEKS(state, weeks) {
      state.weeks = weeks && weeks > 0 ? weeks : 8;
    },
    RESET(state) {
      state.loading = false;
      state.error = null;
      state.data = null;
    },
  },

  actions: {
    async fetchImpactAnalysis({ commit, state, rootGetters }, overrides = {}) {
      const projectId = overrides.projectId || rootGetters['pmProject/selectedProjectId'];
      if (!projectId) {
        commit('RESET');
        return null;
      }

      const weeks = overrides.weeks ?? state.weeks ?? 8;
      commit('SET_WEEKS', weeks);
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const data = await pmImpactAnalysisService.getProjectImpactAnalysis(projectId, { weeks });
        commit('SET_DATA', data);
        return data;
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Failed to load impact analysis');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
